import { useCallback } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIsJiraUserFirstActiveWithinXDays } from './useIsJiraUserFirstActiveWithinXDays.tsx';
import { useYbrIsNewUserCrossFlow } from './useYbrIsNewUserCrossFlow.tsx';

export const useYbrCrossFlowSuppression = (): { shouldSuppress: () => boolean } => {
	const [userIsNewUser] = useYbrIsNewUserCrossFlow();
	const [userIsWithin30Days] = useIsJiraUserFirstActiveWithinXDays(30);

	const shouldSuppress = useCallback(() => {
		if (userIsNewUser && expVal('jira_ybr_first_batch_cross_flow', 'isYBREnabled', false)) {
			return userIsWithin30Days;
		}

		return false;
	}, [userIsNewUser, userIsWithin30Days]);

	return {
		shouldSuppress,
	};
};
